<template>
  <div class="language-selector">
    <select
      v-model="currentLocale"
      @change="changeLanguage"
      class="language-select"
    >
      <option value="fr">Français</option>
      <option value="en">English</option>
      <option value="es">Español</option>
    </select>
  </div>
</template>

<script>
export default {
  name: "LanguageSelector",
  data() {
    return {
      currentLocale: this.$i18n.locale,
    };
  },
  methods: {
    changeLanguage() {
      this.$i18n.locale = this.currentLocale;
      localStorage.setItem("locale", this.currentLocale);
    },
  },
};
</script>

<style scoped>
.language-selector {
  display: flex;
  align-items: center;
}

.language-select {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
  font-size: 14px;
  cursor: pointer;
  outline: none;
  transition: border-color 0.2s;
}

.language-select:hover {
  border-color: #007bff;
}

.language-select:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}
</style>
